import { createFileRoute } from '@tanstack/react-router';

import { GeneralSettingsPage } from '@/features/settings';

export const Route = createFileRoute('/_authenticated/_withWorkspace/settings/general')({
  component: GeneralSettingsPage,
});
